import { render, staticRenderFns } from "./StandBy.vue?vue&type=template&id=832b9bf4&scoped=true&"
import script from "./StandBy.vue?vue&type=script&lang=js&"
export * from "./StandBy.vue?vue&type=script&lang=js&"
import style0 from "./StandBy.vue?vue&type=style&index=0&id=832b9bf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832b9bf4",
  null
  
)

export default component.exports